<template>
  <div>
    <div class="reappro reappro--mobile" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
      <ReapproHeader :recept="true" :item="this.detail"></ReapproHeader>
      <ProductFamilyList class="categories--reappro"></ProductFamilyList>
      <div class="reappro__products">
        <ProductReappro :item="item" v-for="item in this.detail.lines" :recept="true" :update="true"
          :showQuantity="'shipped'" :key="item.id"></ProductReappro>
      </div>
      <div class="reappro__btns">
        <a href="" class="reappro__btn btn btn--valider" @click.prevent="showModalVR = 1">
          <span class="btn__text">Je valide la réception</span>
          <img src="/static/img/pictos/valider.svg" class="btn__picto" alt="" />
        </a>
        <div href="" class="reappro__info info">
          <span class="info__total">Total :</span>
          <span class="info__quantity">{{ this.detail.lines ? this.detail.lines.length : 0 }}</span>
          <span class="info__quantity-text">produits</span>
        </div>
      </div>
    </div>
    <ReapproModal v-if="showModalVR == 1" @close="showModalVR = 0" :type="'valid-recept'" :id="this.detail.id"
      :item="this.detail"></ReapproModal>
  </div>
</template>

<script>
import ReapproHeader from "@/components/Reappro/ReapproHeader";
import ProductFamilyList from "@/components/ProductFamily/ProductFamilyList";
import ProductReappro from "@/components/Product/ProductReappro";
import ReapproModal from "@/components/Reappro/ReapproModal";

export default {
  name: "ReapproRecept",
  data() {
    return {
      showModalVR: 0,
      detail: {
        id: null,
      },
      total: 0,
    };
  },
  mounted() {
    const self = this;

    this.$store.dispatch("product/getAllCurrent").then(() => {
      this.$store.dispatch("order/getItem", {id: this.$route.params.id}).then(() => {
        this.detail = this.$store.getters["order/getItem"](this.$route.params.id);
        this.$store.dispatch("hideLoader");
      });
    });
  },
  methods: {},
  components: {
    ReapproHeader,
    ProductFamilyList,
    ProductReappro,
    ReapproModal,
  },
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: white;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $grisclair;
  border-radius: 20px;
  height: 5px;
}

.reappro {
  display: flex;

  &--mobile {
    flex-direction: column;

    .reappro__products {
      padding: 20px;
    }

    .imputation__text {
      margin-right: 5px;
    }

    .product {
      .imputation__selector {
        margin-left: 0;
      }
    }
  }
}

.reappro__btns {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 20px;
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 75px;
  z-index: 19;

  .reappro__btn {
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    height: 75px;
    color: white;
    outline: none;
    border-radius: 0;
    padding: 0 20px;

    img {
      width: 25px;
      margin-left: 5px;
      margin-left: 15px;
    }

    span {
      font-size: 11px;
      font-family: "ClanPro";
      flex: 1;
      text-align: left;
    }

    &.btn--valider {
      background-color: $vert;
      justify-content: space-between;
      align-items: center;
    }

    &.btn--delete {
      background-color: $color1;
      justify-content: space-between;
    }
  }

  .info {
    width: 50%;
    height: 75px;
    line-height: 70px;
    background-color: white;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    text-align: center;
    justify-content: center;

    &__total {
      font-family: "ClanProBold";
      color: $color1;
      text-transform: uppercase;
      font-size: 12px;
    }

    &__quantity {
      height: 55px;
      width: 55px;
      border-radius: 50%;
      font-family: "ClanFFBlack";
      font-size: 20px;
      color: $grisfonce;
      border: 1px solid $grisclair;
      text-align: center;
      line-height: 55px;
      margin: 0 10px;
    }

    &__quantity-text {
      color: $grisfonce;
      font-family: "ClanPro";
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reappro/ReapproRecept.vue